import React, { ComponentProps } from 'react';
import { Flex, Square } from '@grubhubprod/gh-cookbook-react';

type FlexProps = ComponentProps<typeof Flex>;

export type DataTableToolbarProps = Partial<Pick<FlexProps, 'justifyContent'>>;

export const DataTableToolbar: React.FC<DataTableToolbarProps> = ({
  children,
  justifyContent = 'flex-start',
}) => (
  <Square
    inset="md"
    borderBottom="1px solid"
    borderColor="lightLine"
    backgroundColor="untintedBackground"
  >
    <Flex alignItems="center" justifyContent={justifyContent}>
      {children}
    </Flex>
  </Square>
);
